export default __webpack_public_path__ + "static/media/loader.ae6e10aa.svg";